var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FractionJs = require('fraction.js');

var Prefixer = require('./prefixer');

var utils = require('./utils');

var REGEXP = /(min|max)-resolution\s*:\s*\d*\.?\d+(dppx|dpcm|dpi|x)/gi;
var SPLIT = /(min|max)-resolution(\s*:\s*)(\d*\.?\d+)(dppx|dpcm|dpi|x)/i;

var Resolution = /*#__PURE__*/function (_Prefixer) {
  "use strict";

  _inherits(Resolution, _Prefixer);

  var _super = _createSuper(Resolution);

  function Resolution() {
    _classCallCheck(this, Resolution);

    return _super.apply(this, arguments);
  }

  _createClass(Resolution, [{
    key: "prefixName",
    value:
    /**
     * Return prefixed query name
     */
    function prefixName(prefix, name) {
      if (prefix === '-moz-') {
        return name + '--moz-device-pixel-ratio';
      } else {
        return prefix + name + '-device-pixel-ratio';
      }
    }
    /**
     * Return prefixed query
     */

  }, {
    key: "prefixQuery",
    value: function prefixQuery(prefix, name, colon, value, units) {
      value = new FractionJs(value); // 1dpcm = 2.54dpi
      // 1dppx = 96dpi

      if (units === 'dpi') {
        value = value.div(96);
      } else if (units === 'dpcm') {
        value = value.mul(2.54).div(96);
      }

      value = value.simplify();

      if (prefix === '-o-') {
        value = value.n + '/' + value.d;
      }

      return this.prefixName(prefix, name) + colon + value;
    }
    /**
     * Remove prefixed queries
     */

  }, {
    key: "clean",
    value: function clean(rule) {
      var _this = this;

      if (!this.bad) {
        this.bad = [];

        var _iterator = _createForOfIteratorHelper(this.prefixes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var prefix = _step.value;
            this.bad.push(this.prefixName(prefix, 'min'));
            this.bad.push(this.prefixName(prefix, 'max'));
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      rule.params = utils.editList(rule.params, function (queries) {
        return queries.filter(function (query) {
          return _this.bad.every(function (i) {
            return !query.includes(i);
          });
        });
      });
    }
    /**
     * Add prefixed queries
     */

  }, {
    key: "process",
    value: function process(rule) {
      var _this2 = this;

      var parent = this.parentPrefix(rule);
      var prefixes = parent ? [parent] : this.prefixes;
      rule.params = utils.editList(rule.params, function (origin, prefixed) {
        var _iterator2 = _createForOfIteratorHelper(origin),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var query = _step2.value;

            if (!query.includes('min-resolution') && !query.includes('max-resolution')) {
              prefixed.push(query);
              continue;
            }

            var _iterator3 = _createForOfIteratorHelper(prefixes),
                _step3;

            try {
              var _loop = function _loop() {
                var prefix = _step3.value;
                var processed = query.replace(REGEXP, function (str) {
                  var parts = str.match(SPLIT);
                  return _this2.prefixQuery(prefix, parts[1], parts[2], parts[3], parts[4]);
                });
                prefixed.push(processed);
              };

              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            prefixed.push(query);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        return utils.uniq(prefixed);
      });
    }
  }]);

  return Resolution;
}(Prefixer);

module.exports = Resolution;